import styled from "@emotion/styled"

const SectionElement = styled.section`
    width: 100%;
`

export default SectionElement